import apiService from './config';

export const getTravelRoute = (
  journey_id: string,
): Promise<{ geometry: string }> =>
  apiService.get(`route/trucker/${journey_id}`);
